export default {
  name: "SnackbarMessage",

  props: {
    errorMessage: {
      type: String,
      default: "",
    },
    successMessage: {
      type: String,
      default: "",
    },
    duration: {
      type: Number,
      default: 5000,
    },
  },

  emits: ["dismiss-error", "dismiss-success"],

  data() {
    return {
      dismiss_timeout: null,
    };
  },

  computed: {
    is_error() {
      return Boolean(this.errorMessage);
    },

    message() {
      return this.errorMessage || this.successMessage;
    },

    variant_class() {
      return this.is_error ? "text-bg-danger" : "text-bg-success";
    },

    icon_class() {
      return this.is_error ? "bi bi-exclamation-circle-fill" : "bi bi-check-circle-fill";
    },

    aria_live() {
      return this.is_error ? "assertive" : "polite";
    },
  },

  watch: {
    message: {
      immediate: true,
      handler(message) {
        this.schedule_dismiss(message);
      },
    },
  },

  beforeUnmount() {
    this.clear_dismiss_timeout();
  },

  methods: {
    clear_dismiss_timeout() {
      if (this.dismiss_timeout) {
        clearTimeout(this.dismiss_timeout);
        this.dismiss_timeout = null;
      }
    },

    schedule_dismiss(message) {
      this.clear_dismiss_timeout();

      if (!message || this.duration <= 0) {
        return;
      }

      this.dismiss_timeout = setTimeout(() => {
        this.dismiss();
      }, this.duration);
    },

    dismiss() {
      this.clear_dismiss_timeout();
      this.$emit(this.is_error ? "dismiss-error" : "dismiss-success");
    },
  },
};
